import React from 'react'

import PropTypes from 'prop-types'
import { isUndefined } from 'lodash-es'
import { FormattedMessage } from 'react-intl'

import { formatDuration, generateThumbnailUrl } from '../../utils'
import './VideoItemComponent.scss'

class VideoItemComponent extends React.Component {
  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
    this.renderMeta = this.renderMeta.bind(this)
  }

  onClick() {
    const { reorderable, onClick, video } = this.props

    if (!reorderable && onClick) {
      onClick(video)
    }
  }

  getTag() {
    const { onClick, linkVideos } = this.props

    if (isUndefined(onClick) && linkVideos) {
      return 'a'
    }

    return 'div'
  }

  getVideoLink() {
    const videoId = this.getId()
    return `/manage/video/${videoId}`
  }

  getId() {
    const { video } = this.props

    return video.photo_id || video.live_id || video.object_id
  }

  renderMeta() {
    const { video, showAlbum, showDuration } = this.props
    let album = video.album_title

    if (!showAlbum) {
      album = ''
    }

    if (video.video_encoded_p === 0) {
      return (
        <div className="video-item-meta is-encoding">
          <FormattedMessage defaultMessage="Encoding in progress" />
          ...
        </div>
      )
    }

    if (video.photo_id) {
      return (
        <div className="video-item-meta">
          <div className="video-item-album">{album || <span>&nbsp;</span>}</div>
          {showDuration ? (
            <div className="video-item-length">
              {formatDuration(video.video_length)}
            </div>
          ) : null}
          <div className="video-item-title">{video.title}</div>
        </div>
      )
    }

    if (video.live_id) {
      return (
        <div className="video-item-meta">
          <div className="video-item-title">{video.name}</div>
        </div>
      )
    }

    return null
  }

  render() {
    const {
      video,
      selectable,
      reorderable,
      onMouseDown,
      onMouseEnter,
      dragging,
      onClick,
      linkVideos,
      showMeta,
    } = this.props

    if (!video.photo_id && !video.live_id && !video.object_id) {
      return <div className="video-item-component video-item-empty" />
    }

    const classNames = ['video-item-component']

    if (video.selected_p === 1) {
      classNames.push('selected')
    }

    if (selectable) {
      classNames.push('selectable')
    }

    let extraProps = {}

    if (reorderable) {
      extraProps = {
        onMouseDown: (e) => {
          e.preventDefault()
          onMouseDown(e, video, this.element)
        },
        onMouseEnter: () => {
          onMouseEnter(video)
        },
      }

      if (dragging) {
        classNames.push('dragging')
      }
    }

    if (isUndefined(onClick) && linkVideos) {
      extraProps.href = this.getVideoLink()
    }

    const Tag = this.getTag()

    return (
      <Tag
        className={classNames.join(' ')}
        onClick={this.onClick}
        {...extraProps}
      >
        <div className="video-item-sizer">
          <div
            className="video-item-inner"
            ref={(itemElement) => {
              this.element = itemElement
            }}
          >
            <div
              className="video-item-background"
              style={{ backgroundImage: `url(${generateThumbnailUrl(video)})` }}
            />
            {showMeta ? this.renderMeta() : null}
            {selectable ? <div className="selector" /> : null}
          </div>
        </div>
      </Tag>
    )
  }
}

VideoItemComponent.propTypes = {
  video: PropTypes.object.isRequired,
  showMeta: PropTypes.bool,
  showAlbum: PropTypes.bool,
  showDuration: PropTypes.bool,
  selectable: PropTypes.bool,
  reorderable: PropTypes.bool,
  dragging: PropTypes.bool,
  onClick: PropTypes.func,
  linkVideos: PropTypes.bool,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
}

VideoItemComponent.defaultProps = {
  showMeta: true,
  showAlbum: true,
  showDuration: true,
  selectable: false,
  reorderable: false,
}

export default VideoItemComponent
